import React, { CSSProperties, useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../Core/hooks';
import { Link } from 'react-router-dom';
import { VscTriangleDown } from "react-icons/vsc";
import { BiSearch } from "react-icons/bi";
import { RxAvatar } from "react-icons/rx";
import { LuKanban } from "react-icons/lu";
import Avatar from "../../Components/Avatar";
//import { getProject } from '../Store/Project';
import { getSettings, heartBeat, setSearchText, setSettingsStatus } from '../../Store/Settings';
import { getRoadmap, saveRoadmapMode } from '../../Store/Roadmap';
import { getProject, saveProjectMode } from '../../Store/Project';
import { SettingsContextParam } from "../../Models/Requests/SettingsContextParam";
import SettingsContext from "../../Modals/SettingsContext";
//import { Roadmap } from '../Models/Roadmap';
import { handleLoadComponent } from '../../Helpers/handleLoadComponent';
import { RxDashboard } from 'react-icons/rx';
import { IoPeopleOutline } from 'react-icons/io5';
import { IoMapOutline } from 'react-icons/io5';
import { IoSettingsOutline } from 'react-icons/io5';
import { BsLightning } from "react-icons/bs";
import { IoIosList } from "react-icons/io";
import { IoCalendarOutline } from "react-icons/io5";
import { RoadmapCategory } from '../../Models/RoadmapCategory';
import { getChat } from '../../Store/Chat';
import { getUser, refreshAccessToken, setLastHeartbeat } from '../../Store/Auth';
import { getPlans, getStripe } from '../../Store/Stripe';
import { differenceInDays } from 'date-fns';
import { BillingContextMenuParam } from '../../Models/Requests/BillingContexMenuParam';
import BillingContextMenu from '../../Modals/BillingContextMenu';
import { StripePlan } from '../../Models/Requests/StripePlan';
import { StripePayment } from '../../Models/Requests/StripePayment';
import { addDays, parseISO, format } from 'date-fns';
import { IoReturnDownBackOutline } from "react-icons/io5";
import { FaHammer } from "react-icons/fa";

function TopNav() {

    const dispatch = useAppDispatch();
    const userState = useAppSelector(getUser);
    const stripeState = useAppSelector(getStripe);
    const settingsState = useAppSelector(getSettings);
    const roadmapState = useAppSelector(getRoadmap);
    const projectState = useAppSelector(getProject);
    const chatState = useAppSelector(getChat);
    const [settingsContextParams, setSettingsContextParams] = useState<SettingsContextParam>();
    const [billingContextMenuParams, setBillingContextMenuParams] = useState<BillingContextMenuParam>();
    const [search, setSearch] = useState("");
    const [showSubscriptionSuccess, setShowSubscriptionSuccess] = useState(false);
    const [version, setVersion] = useState("");
    const [newVersionExists, setNewVersionExists] = useState(false);

    useEffect(() => {
        setVersion(settingsState.version);
        const intervalId = setInterval(() => {
            dispatch(heartBeat());
            //dispatch(getVersion());
        }, 60000);
        return () => clearInterval(intervalId);
    },[]);  
    
    useEffect(() => {
        if (settingsState.version !== "" && settingsState.version !== version) {
            if (version === "") {
                setVersion(settingsState.version);
            } else {
                setNewVersionExists(true);
                //alert("There is a software update available");
            }
        }
    }, [settingsState.version]);

    useEffect(() => {
        if (stripeState.clientSecret !== "") {
            setShowSubscriptionSuccess(true);
            setTimeout(() => setShowSubscriptionSuccess(false), 5000);
        }
    },[stripeState.clientSecret]);

    useEffect(() => {
        if (settingsState.status === "heartbeat") {
            dispatch(setSettingsStatus("idle"));
            dispatch(setLastHeartbeat(format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS")));
        }
    },[settingsState.status]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.currentTarget.value);
        dispatch(setSearchText(e.currentTarget.value));
    }

    const popSettingsWindow = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        //closeContainer();
        setSettingsContextParams({ _id: "1", event: e }); 
    }

    const returnToRoadmap = () => {
        handleLoadComponent(dispatch, "roadmap", settingsState.settings);
    }

    const handleShowBilling = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        setBillingContextMenuParams({ id: '1', event: e }); 
    }

    const refreshBrowser = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setVersion(settingsState.version);
        setNewVersionExists(false);
        window.location.reload();
    }

    let settings = settingsState.settings;
    let currentMember = undefined;
    //let roadmap: Roadmap | undefined;
    let loadedComponentName = "name of loaded component goes here";
    let componentNav: JSX.Element = (<div></div>);
    let showSearchWork = true;

    let category: RoadmapCategory | undefined = undefined;
    let project = projectState.projects.find(p => p.loaded);
    let recentPayment: StripePayment | null = stripeState.mostRecentPayment;

    let plan: StripePlan | undefined = undefined;

    if (recentPayment) {
        plan = stripeState.plans.find(p => p._id === recentPayment!.stripePlanId);
    }
    
    if (project) {
        category = roadmapState.categories.find(c => c._id === project!.categoryId);
        // let listStyle: CSSProperties = (category) ? { backgroundColor : category.backgroundColor, color: category.fontColor } : {};
    }

    if (settings.loadedComponentType === "global_herdr") {
        showSearchWork = false;
        componentNav = (
            <div style={{ fontSize: "14pt", fontWeight: "550" }}>
                Herdr Platform Settings
            </div>
        );

    } else if (settings.loadedComponentType === "chat") {

        let channel = chatState.channels.find(c => c.loaded);
        if (channel) {
            let name = (channel.name.length <= 60) ? channel.name : channel.name.substring(0,60) + "...";
            componentNav = (
                <div style={{ fontWeight: "bold", fontSize: "12pt" }}>
                    {name}
                </div>
            );
        }

    } else if (settings.loadedComponentType === "roadmap") {
        let roadmap = roadmapState.roadmaps.find(r => r.loaded);
        if (roadmap) {
            loadedComponentName = roadmap.name;

            let dashboardClass = (roadmap.mode === "dashboard") ? "subTopNavSelected" : "subTopNav";
            let generateClass = (roadmap.mode === "generate") ? "subTopNavSelected" : "subTopNav";
            let roadmapClass = (roadmap.mode === "roadmap") ? "subTopNavSelected" : "subTopNav";
            let membersClass = (roadmap.mode === "members") ? "subTopNavSelected" : "subTopNav";
            //let settingsClass = (roadmap.mode === "settings") ? "subTopNavSelected" : "subTopNav";

            if (roadmap._id) {
                componentNav = (
                    <>
                    {roadmap.roadmap && roadmap.permission && 
                        (roadmap.permission.toString() === "owner" || roadmap.permission.toString() === "admin") &&
                        <div className={dashboardClass} style={{ padding: "0px 15px 0px 0px" }} 
                            onClick={() => dispatch(saveRoadmapMode({ _id: roadmap!._id, mode: "dashboard"}))}>
                            <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                                <RxDashboard size={16} />
                            </div>
                            <div className={dashboardClass}>
                                Dashboard
                            </div>
                        </div>
                    }
                    
                    <div className={roadmapClass} style={{ padding: "0px 15px" }} 
                        onClick={() => dispatch(saveRoadmapMode({ _id: roadmap!._id, mode: "roadmap"}))}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoMapOutline size={16} />
                        </div>
                        <div className={roadmapClass}>
                            Roadmap
                        </div>
                    </div>
                    {/*
                    <div className={generateClass} style={{ padding: "0px 15px" }} 
                        onClick={() => dispatch(saveRoadmapMode({ id: roadmap!.id, mode: "generate"}))}> 
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <BsLightning size={16} />
                        </div>
                        <div className={generateClass}>
                            Generate
                        </div>
                    </div>
                    */}
                    {roadmap.roadmap && roadmap.permission && 
                        (roadmap.permission.toString() === "owner" || roadmap.permission.toString() === "admin") &&
                        <div className={membersClass} style={{ padding: "0px 15px" }} 
                            onClick={() => dispatch(saveRoadmapMode({ _id: roadmap!._id, mode: "members"}))}>
                            <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                                <IoPeopleOutline size={18} />
                            </div>
                            <div className={membersClass}>
                                Members
                            </div> 
                        </div>
                    }
                    {/*
                    <div className={settingsClass} style={{ padding: "0px 10px" }} 
                       onClick={() => dispatch(saveRoadmapMode({ id: roadmap!.id, mode: "settings"}))}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoSettingsOutline size={16} />
                        </div>
                        <div className={settingsClass}>
                            Settings
                        </div> 
                    </div>
                    */}
                    </>
                );
            }
        }
    } else if (settings.loadedComponentType === "work") {

        //let project = projectState.projects.find(p => p.loaded);
        if (project) {

            let calendarClass = (project.mode === "calendar") ? "subTopNavSelected" : "subTopNav";
            let boardClass = (project.mode === "board") ? "subTopNavSelected" : "subTopNav";
            let listClass = (project.mode === "list") ? "subTopNavSelected" : "subTopNav";
            let membersClass = (project.mode === "members") ? "subTopNavSelected" : "subTopNav";

            if (project._id) {
                componentNav = (
                    <>

                    <div className="subTopNav" style={{ padding: "0px 15px 0px 0px" }} 
                        onClick={() => returnToRoadmap()}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoReturnDownBackOutline size={16} />
                            {/*IoMapOutline */}
                        </div>
                        <div className="subTopNav">
                            Roadmap
                        </div>
                    </div>
                    <div className={boardClass} style={{ padding: "0px 15px 0px 0px" }} 
                        onClick={() => dispatch(saveProjectMode({ _id: project!._id, mode: "board"}))}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <LuKanban size={16} />
                        </div>
                        <div className={boardClass}>
                            Board
                        </div>
                    </div>


                    {/*
                    <div className={listClass} style={{ padding: "0px 15px" }} 
                        onClick={() => dispatch(saveProjectMode({ id: project!.id, mode: "list"}))}> 
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoIosList size={16} />
                        </div>
                        <div className={listClass}>
                            List
                        </div>
                    </div>
                    <div className={calendarClass} style={{ padding: "0px 15px" }} 
                        onClick={() => dispatch(saveProjectMode({ id: project!.id, mode: "calendar"}))}>
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoCalendarOutline size={16} />
                        </div>
                        <div className={calendarClass}>
                            Calendar
                        </div>
                    </div>
                    */}
                    {/*
                    <div className={membersClass} style={{ padding: "0px 15px" }} 
                        onClick={() => dispatch(saveProjectMode({ id: project!.id, mode: "members"}))}>
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoPeopleOutline size={17} />
                        </div>
                        <div className={membersClass}>
                            Members
                        </div> 
                    </div>
                    */}
                    </>
                );
            }
        }
    }

    
    //if (roadmap) {
    
    let searchPlaceholder = "";
    if (settingsState.settings.loadedComponentType === "roadmap") {
        let roadmap = roadmapState.roadmaps.find(r => r.loaded);
        if (roadmap) {
            if (roadmap.mode === "members") {
                searchPlaceholder = "Search members...";
            } else {
                searchPlaceholder = "Search your items...";
            }
        }
    } else if (settingsState.settings.loadedComponentType === "work") {
        searchPlaceholder = "Search your work...";
    } else if (settingsState.settings.loadedComponentType === "chat") {
        searchPlaceholder = "Search your chat...";
    } else {
        searchPlaceholder = "Search your items...";
    }

    let catStyle: CSSProperties = {
        backgroundColor : (category) ? category.backgroundColor : "#efefef",
        color: (category) ? category.fontColor : "#000",
        borderRadius: "30px",
        padding: "4px 10px",
        cursor: "pointer",
        fontSize: "9pt",
        display: "flex", 
        alignItems: "center", 
        position: "relative", 
        top: "1px"
    }
    let trialMessage = "FREE, SOLO";
    /*
    let trialMessage = "14 Day Trial";
    let daysLeft = 0;

    if (!recentPayment && userState.created) {
        daysLeft = 14 - differenceInDays(new Date(), new Date(userState.created));
        trialMessage = (daysLeft === 1) ? daysLeft + " Day Left" : daysLeft + " Days Left";
    }

    // Subscription expired
    if (recentPayment && !recentPayment.active) {
        daysLeft = Math.ceil((addDays(new Date(recentPayment.payment), 30).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
        trialMessage = (daysLeft === 1) ? daysLeft + " Day Left" : daysLeft + " Days Left";
    }

    // If days left is zero or negative, adjust message
    if (daysLeft <= 0) {
        trialMessage = "Account Expired";
    }
    */
    return (
        <>
        {newVersionExists &&
            <div className="updateBannerDiv">
                <FaHammer color="#6B7280" size={20} />
                <span className="updateBannerSpan">
                    We've been hard at work and just released a new version of the app 
                </span>
                <Link to="" onClick={(e) => refreshBrowser(e)} className="updateBannerLink">
                    Take me there!
                </Link>
            </div>
        }
        <div style={{ width: "100%", padding: "7px 15px", backgroundColor: "#fff", 
            borderTopRightRadius: "20px", display: "flex", alignItems: "center",
            justifyContent: "space-between"
            }}>
            <div style={{ display: "inline-block", marginRight: "auto" }}>
                {/*
                <div style={{ display: "inline-block", paddingRight: "5px", position: "relative", top: "-2px" }}>
                    <IoMapOutline size={19} color="#c44f01" />
                </div>
                <div style={{ display: "inline-block", fontSize: "13pt", fontWeight: "550", paddingRight: "5px" }}>
                    {loadedComponentName}
                </div>
                <div style={{ display: "inline-block" }}>
                    <VscTriangleDown size={14} />
                </div>
                */}
                <div style={{ fontSize: "10pt" }}>
                    {componentNav}
                </div>
            </div>
            {/*
            {(settingsState.settings.loadedComponentType === "work") &&
                <div style={catStyle} onClick={() => returnToRoadmap()}>
                    <b>{category ? category.title : "Uncategorized"}</b> {": Return to Roadmap"}
                </div>
            }
            */}
            <div style={{ display: "flex",alignItems: "center" }}>
                {showSubscriptionSuccess &&
                    <div className="success" style={{ fontSize: "11pt", marginTop: "0px", 
                        display: "inline-block", position: "relative", padding: "5px 20px" }}>
                        You're in - thanks for subscribing!
                    </div>
                }
                {showSearchWork &&
                <>
                    <div style={{ display: "inline-block", position: "relative", left: "26px" }}>
                        <BiSearch color="gray" size={18} />
                    </div>
                    <div style={{ display: "inline-block", marginRight: "20px" }}>
                        <input type="text" className="navSearchInput" placeholder={searchPlaceholder} 
                            value={search}
                            onChange={(e) => handleSearchChange(e)}
                            //onChange={(e) => setSearch(e.currentTarget.value)}
                            //onKeyDown={(e) => handleSaveSearch(e)} 
                            //onBlur={(e) => handleSaveSearch(e)}
                        />
                    </div>
                </>
                }

                {userState.earlyAdapter ? 
                    <div style={{ display: "inline-block", fontSize: "8pt", marginRight: "20px" }}>
                          <div style={{ fontWeight: "bold" }}>
                              EARLY ADOPTER
                          </div>
                          <div style={{ fontWeight: "bold", color: "#007AFF" }}>
                              FREE, NO LIMITS&nbsp;
                          </div>
                      </div>                  
                :                
                    <>
                    {((recentPayment === null && userState.created) || (recentPayment && !recentPayment.active)) ?
                        <div style={{ display: "inline-block", fontSize: "8pt", marginRight: "20px", cursor: "pointer" }}
                            onClick={(e) => handleShowBilling(e)}>
                            <div style={{ fontWeight: "bold" }}>
                                {trialMessage}
                            </div>
                            <div style={{ fontWeight: "bold", color: "#007AFF" }}>
                                {(!recentPayment) ? "Upgrade" : "Resubscribe"}&nbsp;
                                <VscTriangleDown size={14} color="#007AFF" />
                            </div>
                        </div>
                    :
                        <div style={{ display: "inline-block", fontSize: "8pt", marginRight: "20px", cursor: "pointer" }}
                            onClick={(e) => handleShowBilling(e)}>
                            <div style={{ fontWeight: "bold" }}>
                                {(plan) && plan.name.toUpperCase()}
                            </div>
                            <div style={{ fontWeight: "bold", color: "#007AFF" }}>
                                Change&nbsp;
                                <VscTriangleDown size={14} color="#007AFF" />
                            </div>
                        </div>
                    }
                    </>
                }
                <div onClick={(e) => popSettingsWindow(e)} style={{ cursor: "pointer" }}>    
                    <Avatar size="small" member={currentMember} />
                </div>
            </div>
        </div>
        <SettingsContext params={settingsContextParams} />
        <BillingContextMenu params={billingContextMenuParams} />
        </>
    );
}

export default TopNav;